//@flow
import React from "react";
import { connect } from "react-redux";
import SelecaoToleranciaInteiroNaoNegativo from "./SelecaoToleranciaInteiroNaoNegativo";
import {
  type ActionCreator,
  getToleranciaDiasValorMercadoSelecionada,
  selecionarToleranciaDiasValorMercado,
} from "../../../../state";

import { Translate } from "@quantum/i18n";

type Props = {
  toleranciaDiasValorMercadoSelecionada: number,
  selecionarToleranciaDiasValorMercado: ActionCreator,
};

function SelecaoToleranciaDiasValorMercado({
  toleranciaDiasValorMercadoSelecionada,
  selecionarToleranciaDiasValorMercado,
}: Props) {
  function onChange(toleranciaDiasValorMercado) {
    selecionarToleranciaDiasValorMercado(toleranciaDiasValorMercado);
  }

  return (
    <div className="ConfiguracaoMedida">
      <label className="ConfiguracaoMedida__label ConfiguracaoMedida__label--block">
        <Translate>configuracaoRelatorio.tolerancia</Translate>{" "}
        <small className="ConfiguracaoMedida__hint">
          (<Translate>configuracaoRelatorio.valorMercado</Translate>)
        </small>
      </label>
      <SelecaoToleranciaInteiroNaoNegativo
        toleranciaSelecionada={toleranciaDiasValorMercadoSelecionada}
        onChange={onChange}
      >
        <label className="ConfiguracaoMedida__label">
          <Translate>configuracaoRelatorio.Dias</Translate>
        </label>
      </SelecaoToleranciaInteiroNaoNegativo>
    </div>
  );
}

export default connect(
  state => ({
    toleranciaDiasValorMercadoSelecionada: getToleranciaDiasValorMercadoSelecionada(
      state
    ),
  }),
  { selecionarToleranciaDiasValorMercado }
)(SelecaoToleranciaDiasValorMercado);
